import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetEnterpriseMessages } from './messages';

export interface useGetEnterpriseOptions {
  shouldFetch?: boolean;
}

export function useGetEnterprise(
  enterpriseId: number | undefined,
  options?: useGetEnterpriseOptions,
) {
  const mergedOptions: useGetEnterpriseOptions = {
    shouldFetch: true,
    ...options,
  };

  const { enterpriseApi } = usePrivate();

  const results = useSWR(
    enterpriseApi && mergedOptions.shouldFetch
      ? `/api/Enterprise/${enterpriseId}`
      : null,
    () => enterpriseApi?.apiEnterpriseGet(enterpriseId),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetEnterpriseMessages['useGetEnterprise.fetch.unexpectedError'],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetEnterprise> error fetching enterprise.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !enterpriseApi;

  return { ...results, isLoadingOrValidating };
}
